import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import Circle_Write3 from "../../components/ExcerciseTypes/Circle_Write3";

const json = {
  5: {
    unit: "Review 2",
    id: "4WB-R2-P49-E5",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page31/Key/E5answerKey.png",
    component: Circle_Write,
    // checkUppercase: true,
    isHiddenCheck: true,
    titleQuestion: [
      {
        num: "5",
        title: `
      			Khoanh vào chữ đặt trước câu trả lời đúng.
      		  `,
        color: "rgb(99,197,244)",
      },
    ],
    
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
        Nháy chuột vào chữ đặt trước câu trả lời đúng.
        </span>
        <video src="Audios/bt_fpt_ai/guide/p31_e5.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    question: {
      Write: {
        isHiddenCheck: true,
        maxLength: 10,
        inputStyle: {
          width: 250,
          fontSize: 24,
          textAlign: "center",
          height: 29,
          paddingBottom: 10,
          textTransform: "uppercase",
        },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: 5,
          // borderColor: "transparent",
          fontWeight: 700,
          color: "rgb(88,147,198)",
        },
        // initialWordStyle: { fontWeight: 'bold', border: 'none', borderRadius: '50%', borderColor: 'transparent' },
        selectWordStyle: {
          padding: 5,
          border: "2px solid black",
          borderRadius: "50%",
          // borderColor: "",
        },
        limitSelect: 1,
        listWords: [`A <br> B <br> C`],
        answers: ["0-0"],
        initialValue: [],
      },
      Layout: `
      <div style='position: relative;'>

      <img src='img/FriendsPlus/Page31/E5/1.jpg' style='width: 14cm; height: 10cm; margin-left: 200px'><br>
        <div>Ở một ngã tư, bốn anh em chia tay nhau, mỗi người đi theo một con đường dẫn đến một con đường dẫn đến các vương quốc Hoa Đỏ, Rồng, Suối Ếch và Bếp Sắt. Anh cả đi đến vương quốc Rồng. Em út đi theo con đường không tạo với con đường của anh cả một góc bẹt hay góc nhọn.<br>
        Vậy em út đi theo con đường nào?
        </div>
        <div style='display: flex; gap: 15px;'>
                <div><input id='0' type='Circle' /></div>
                <div>
                  <div>Suối Ếch</div>
                  <div>Bếp Sắt</div>
                  <div>Hoa Đỏ</div>
                </div>

        
	    </div>
      `,
    },
  },
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    // audio: "Audios/bt_fpt_ai/p24_intro.mp3",
    // autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page31/Key/E1answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter:true,
    maxLength: 2,
    stylesTextInput: {
      borderBottom: "3px dotted black",
      textAlign: "center",
      background: "none",
      fontSize: 24,
      textTransform: "uppercase",
    },
    inputSize: 200,
    titleQuestion: [
      {
        num: "1",
        title: `Hãy tìm 1 góc tù, 1 góc nhọn và 1 góc bẹt trong hình bên dưới rồi viết tiếp vào chỗ chấm cho thích hợp.
		    `,
        color: "rgb(99,197,244)",
      },
    ],
    
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
        Quan sát hình và điền tên góc và cạnh thích hợp vào chỗ chấm.
        </span>
        <video src="Audios/bt_fpt_ai/guide/p31_e1.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position: relative; line-height: 50px'>
          <img src='/img/FriendsPlus/Page31/E1/1.jpg' style='height:11cm; width: 14cm; margin-bottom: 30px'/><br>
        
        	<div style=''>Góc đỉnh <input id= "0">; cạnh <input id= "1">, <input id= "2"> là góc tù. </div>
          <div style=''>Góc đỉnh <input id= "3">; cạnh <input id= "4">, <input id= "5"> là góc nhọn. </div>
          <div style=''>Góc đỉnh <input id= "6">; cạnh <input id= "7">, <input id= "8"> là góc bẹt. </div>
        
        </div>
        `,
        answer: [
          "M",
          "MB",
          "MC",
          "M / A / O | O | A | M",
          "MB / AE / OB | MB | AE | OB | MD / AC / OM | MD | AC | OM",
          "MB / AE / OB | MB | AE | OB | MD / AC / OM | MD | AC | OM",
          "A / O | O | A",
          "AM / OD | AM | OD | AC / OM | AC | OM",
          "AM / OD | AM | OD | AC / OM | AC | OM",
        ],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    // audio: "Audios/bt_fpt_ai/p24_intro.mp3",
    // autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page31/Key/E2answerKey.jpg",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter:true,
    maxLength: 2,
    stylesTextInput: {
      borderBottom: "3px dotted black",
      textAlign: "center",
      background: "none",
      fontSize: 24,
      textTransform: "uppercase",
    },
    inputSize: 100,
    titleQuestion: [
      {
        num: "2",
        title: `Viết số thích hợp vào chỗ chấm.
		    `,
        color: "rgb(99,197,244)",
      },
    ],
    
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
          Đếm số góc có trong hình và và nháy chuột vào chỗ chấm để điền số góc.
        </span>
        <video src="Audios/bt_fpt_ai/guide/p31_e2.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position: relative; line-height: 50px'>
          <img src='/img/FriendsPlus/Page31/E2/1.jpg' style='height:9cm; width: 12cm; margin-bottom: 30px; margin-left: 220px'/><br>
        
        	<div style=''>Hình trên có <input id= "0"> góc nhọn, <input id= "1"> góc vuông, <input id= "2"> góc tù. </div>
        
        </div>
        `,
        answer: ["6", "4", "16"],
      },
    ],
  },
};

export default json;
